module.exports = __webpack_public_path__ + "static/media/covid_project.0374b0ce.pdf";